<template>
  <div>
    <v-data-table :headers="headers" :items="tableData" :loading="loading" class="elevation-1"
      :hide-default-footer="true">
      <template v-slot:[`item.appVO.actions`]="{ item }">
        <v-btn class="ma-2 white--text" small color="error" @click="appItem = item.appVO, deleteDialog = true">解绑</v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">解绑应用</span>
        </v-card-title>
        <v-card-text class="pb-0">确定要解除该应用的绑定吗？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="deleteDialog = false" text>取消</v-btn>
          <v-btn color="error" @click="unbind(appItem)" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { buildAxios } from '@/plugins/axios'
export default {
  props: {
    schemeData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      headers: [
        { text: '应用名称', value: 'appVO.appName' },
        { text: '英文名称', value: 'appVO.appNameEn' },
        { text: 'appCode', value: 'appVO.appCode' },
        { text: '名称', value: 'appVO.appName' },
        { text: '用户类型', value: 'appVO.appUserType' },
        { text: '平台类型', value: 'appVO.platType' },
        { text: '操作', value: 'appVO.actions' }
      ],
      tableData: [],
      loading: true,
      deleteDialog: false,
      appItem: {}
    }
  },
  mounted () {
    this.getBindList()
  },
  methods: {
    async unbind (item) {
      const request = buildAxios()
      const params = {
        bindCode: item.appCode,
        bindType: 'app',
        scheduleCode: this.schemeData.code
      }
      await request.post('baseScheduleBindInfo/delete', params).then(r => {
        this.$emit('alert', {
          msg: '方案解绑成功！',
          type: 'success'
        })
        this.getBindList()
        this.deleteDialog = false
      }).catch(err => {
        console.log(err)
      })
    },
    async getBindList () {
      const request = buildAxios()
      await request.get('baseScheduleBindInfo/listScheduleBindInfo?scheduleCode=' + this.schemeData.code + '&bindType=app').then(r => {
        this.tableData = r.data.data || []
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang='scss' scoped>

</style>
